import React from 'react';

import { BadgeWrapper, Container, Image, Root, StyledYatHand } from './styles';

type GroupHeaderImageProps = {
    image?: string;
    badge?: React.ReactNode;
    variant?: 'home';
};

// TODO: This should be replaced by <Avatar />.
export const GroupHeaderImage = ({ image, badge, variant, ...others }: GroupHeaderImageProps) => {
    const hasImage = !!(image && image?.length > 0);

    return (
        <Root {...others}>
            <Container $variant={variant} $border={!hasImage}>
                {hasImage ? <Image src={image} /> : <StyledYatHand aria-hidden="true" opacity={0.5} />}
            </Container>
            {badge ? <BadgeWrapper>{badge}</BadgeWrapper> : null}
        </Root>
    );
};
